// extracted by mini-css-extract-plugin
export default {"loader":"style_loader__5QZdj","loader_img":"style_loader_img__RU2s+","animation":"style_animation__vehT9"};